import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avgHide'
})
export class AvgHidePipe implements PipeTransform {

  transform(collection: any, customOrder?: any): any {

    if(customOrder){
      for(let indx in collection){
        if(collection[indx].data[0].label=='Avg'){
            let avg=collection.splice(indx,1)[0];
            //collection.unshift(avg);
        }
      }
    }else{
        for(let indx in collection){
            if(collection[indx][0].label=='Avg'){
                let avg=collection.splice(indx,1)[0];
                //collection.unshift(avg);
            }
        }
    }
    return collection ;
  }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/stats/pipe/avg-hide.pipe.ts